import { createNullableProvideInject } from '@collector/shared-ui'

import { EventDurationConfig } from '../configuration'

export const [provideEventDurationConfig, injectEventDurationConfig] =
  createNullableProvideInject<EventDurationConfig>('eventDurationConfig')
